var Lists = {
    bindDisabilityModal: function() {
        $('#disabilityModal').on('show.bs.modal', function (event) {
            var button = $(event.relatedTarget);
            var disabilityToHide = button.data('hideid');

            var modal = $(this);
            $(this).find('select option').prop('disabled', false);
            $(this).find('select option[value=' + disabilityToHide + ']').prop('disabled', true);
            $(this).find('select').select2('destroy').select2().select2('val', $(this).find('select option:eq(2)').val());
            $(this).find('.disability_id').val(disabilityToHide);
        });
    },

    bindAdditionalSubjectSearch: function() {
        $('.additional-subject-search').select2({
            ajax: {
                url: '/admin/subjects/ajax',
                placeholder: 'Enter name here...',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        });

        var selectedItems = $('.additional_subject_ids');
        selectedItems.each(function(i, el) {
            var input = $(el);
            var $option = $('<option selected="selected">' + input.data('name') + '</option>').val(input.val());
            $('#additional_subjects').append($option).trigger('change');
        });
    },

    bindAssessmentFrameworkSearch: function() {
        $('.assessment-framework-search').select2({
            ajax: {
                url: '/admin/frameworks/ajax',
                placeholder: 'Enter name here...',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        });

        var selectedItems = $('.assessment_framework_ids');
        selectedItems.each(function(i, el) {
            var input = $(el);
            var $option = $('<option selected="selected">' + input.data('name') + '</option>').val(input.val());
            $('#assessment_frameworks').append($option).trigger('change');
        });
    }
};